var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v(" "+_vm._s(_vm.$t('page-not-found'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }